import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./overview-tab.module.scss";
import {
	useGetMostRecentServiceRequestsQuery,
	useLazyGetServiceRequestTypesQuery,
} from "../../../../../service/customersupport-service";
import ActiveRequestCard from "../../components/active-request-card/ActiveRequestCard";
import { ChevronRightIcon } from "../../../../../assets/icons";
import { ApplicationRoutes } from "../../../../../routes";
import Can from "../../../../../guards/Can";
import { CustomerPermissions } from "../../../../../model/permissions/permissions";

const OverviewTab: React.FC = () => {
	const navigate = useNavigate();

	const {
		data: mostRecentRequest,
		isLoading: isLoadingRecent,
	} = useGetMostRecentServiceRequestsQuery();

	const [fetchServiceRequestTypes, {
		data: serviceTypesData,
		isLoading: isLoadingTypes,
		isError: isErrorTypes,
	}] = useLazyGetServiceRequestTypesQuery();

	useEffect(() => {
		fetchServiceRequestTypes({ page: 1, pageSize: 10, isPublished: true });
	}, [fetchServiceRequestTypes]);

	const serviceTypes = serviceTypesData?.items ?? [];
	const isLoading = isLoadingRecent || isLoadingTypes;

	const handleServiceTypePress = (serviceTypeId: string) => {
		navigate(`/${ApplicationRoutes.CUSTOMER_SERVICE_REQUEST_CREATE}`, {
			state: { serviceRequestId: serviceTypeId },
		});
	};

	const handleDetailsPress = () => {
		if (!mostRecentRequest) return;
		navigate(
			`/${ApplicationRoutes.CUSTOMER_SERVICE_REQUEST_DETAIL.replace(":id", String(mostRecentRequest.id))}`
		);
	};

	const handleSeeAllPress = () => {
		navigate(`/${ApplicationRoutes. CUSTOMER_ALL_SERVICE_REQUESTS}`);
	};

	if (isLoading) {
		return (
			<div className={styles.loadingContainer}>
				<div className={styles.skeletonCard} />
				<div className={styles.skeletonList}>
					{Array.from({ length: 4 }).map((_, i) => (
						<div key={i} className={styles.skeletonRow} />
					))}
				</div>
			</div>
		);
	}

	return (
		<div className={styles.container}>
			<ActiveRequestCard
				requestName={mostRecentRequest?.serviceRequest?.name}
				percentage={0}
				requestId={mostRecentRequest?.id}
				onDetailsPress={handleDetailsPress}
			/>

			<Can permission={CustomerPermissions.AddNewServiceRequest}>
			<div className={styles.section}>
				<span className={styles.sectionLabel}>Available Services</span>

				{isErrorTypes ? (
					<div className={styles.errorContainer}>
						<span className={styles.errorText}>Failed to load service types</span>
					</div>
				) : (
					<div className={styles.serviceTypesCard}>
						<div className={styles.serviceTypesList}>
							{serviceTypes.map((serviceType) => (
								<button
									key={serviceType.id}
									className={styles.serviceTypeRow}
									onClick={() => handleServiceTypePress(serviceType.id)}
								>
									<span className={styles.serviceTypeName}>{serviceType.name}</span>
									<ChevronRightIcon className={styles.chevron} aria-hidden />
								</button>
							))}
						</div>

						<button className={styles.seeAllButton} onClick={handleSeeAllPress}>
							See All Services
						</button>
					</div>
				)}
			</div>
			</Can>
		</div>
	);
};

export default OverviewTab;
